import { Radio } from "antd";
import { useTranslation } from "react-i18next";
import Header from "components/header";
import IpgMethod from "./ipgItem";

const PaymentMethods = ({ data, paymentMethod, onChangeMethods }) => {
  const { t } = useTranslation();

  const renderPaymentMethods = () => {
    return (
      <Radio.Group
        className="flex flex-col mt-5 gap-4"
        value={paymentMethod}
        onChange={onChangeMethods}
      >
        {data?.payment_methods?.map((item) => (
          <IpgMethod data={item} paymentMethod={paymentMethod} />
        ))}
      </Radio.Group>
    );
  };

  return (
    <div className=" mt-6">
      <Header title={`${t("payment.choose-method")}:`} />
      {renderPaymentMethods()}
    </div>
  );
};
export default PaymentMethods;
